import { merge } from 'lodash';
export const ScrollAnim = (el, bind) => {
    let options = {
        offset: 0,
        classIn: 'visible',
        classOut: 'invisible'
    };
    merge(options, bind.value);
    var elScrollTop;
    el.classList.add('animated');
    var animated = false;
    window.addEventListener('load', e => {
        elScrollTop = el.getBoundingClientRect().top;
        toggleClasses(elScrollTop, options);
    });
    window.addEventListener('scroll', e => {
        elScrollTop = el.getBoundingClientRect().top;
        if (options.classIn == 'visible') {
        }
        toggleClasses(elScrollTop, options);
    });
    function toggleClasses(scrollTop, options) {
        if (scrollTop < options.offset) {
            el.style.visibility = 'visible';
            el.classList.add(options.classIn);
            el.classList.remove(options.classOut);
        }
        else {
            el.classList.add(options.classOut);
            el.classList.remove(options.classIn);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/directives/scroll-anim.ts
// module id = 9oHi
// module chunks = 2